<template>
    <div v-if="isVisible" class="vehicle-gps-legend">
        <div class="vehicle-gps-legend-header">
            <div class="vehicle-gps-legend-subtitle-action">
                <strong>{{ $t('GPS route legend') }}</strong>
                <Button
                    icon="pi pi-times"
                    severity="danger"
                    variant="text"
                    size="small"
                    @click="clearRoute"
                    v-tooltip.bottom="$t('Remove from map')"
                />
            </div>
            <small class="vehicle-gps-legend-subtitle-hint">
                <i class="pi pi-info-circle"></i>
                {{ $t('Click an arrow on the map to see position details.') }}
            </small>
        </div>

        <Divider class="m-0" />

        <div
            v-for="row in legendRows"
            :key="row.label"
            class="vehicle-gps-legend-row"
        >
            <span class="vehicle-gps-legend-color" :style="{ backgroundColor: row.color }"></span>
            <span class="vehicle-gps-legend-range">{{ $t(row.label) }}</span>
        </div>
    </div>
</template>

<script>
import { createDraggable } from 'animejs'
import { useVehiclesLiveStore } from '@/stores/vehiclesLive'

export default {
    name: 'VehicleGpsRouteLegend',
    setup() {
        const vLive = useVehiclesLiveStore()

        return { vLive }
    },
    computed: {
        isVisible() {
            return !!this.vLive.visibleOnMapMachineId
        },
        legendRows() {
            return this.vLive.gpsRouteLegend
        },
    },
    watch: {
        isVisible: {
            immediate: true,
            handler(visible) {
                if (visible) {
                    if (!this.vLive.legendDraggable) {
                        this.vLive.legendDraggable = createDraggable('.vehicle-gps-legend-control', {
                            container: '#map',
                            snap: 56,
                            dragThreshold: { mouse: 6, touch: 10 },
                        })
                    } else {
                        this.vLive.legendDraggable.enable()
                        this.vLive.legendDraggable.refresh()
                    }
                } else if (this.vLive.legendDraggable) {
                    this.vLive.legendDraggable.disable()
                }
            },
        },
    },
    methods: {
        clearRoute() {
            this.vLive.hideVehicleFromMap()
        },
    },
}
</script>

<style scoped>
.vehicle-gps-legend {
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: #212121;
    color: #fff;
    min-width: 220px;
    max-width: 320px;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #313131;
}

.vehicle-gps-legend-header {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 2px;
}

.vehicle-gps-legend-subtitle-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.vehicle-gps-legend-subtitle-action strong {
    font-size: 1rem;
}

.vehicle-gps-legend-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
}

.vehicle-gps-legend-color {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    border: 1px solid #1a1a1a;
    flex-shrink: 0;
}

.vehicle-gps-legend-range {
    font-size: 12px;
    color: #ebebeb;
}

.vehicle-gps-legend-subtitle-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #c9c9c9;
}
</style>
